import React, { useRef, useState } from "react";
import { Card, CardContent, Typography, Button, List, ListItem, ListItemText, Box } from "@mui/material";
import { useCphDataContext } from "../../hooks/useCphDataContext";
import { useAddFile } from "../../services/ApiHandlerService";

const MAX_UPLOAD_SIZE_BYTES = 25 * 1024 * 1024;

const UploadBrowseCard: React.FC = () => {
    const { selectedIssue } = useCphDataContext();
    const { addFile } = useAddFile();

    if (!selectedIssue) {
        return <Typography variant="body1">No issue selected.</Typography>;
    }

    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const [uploadError, setUploadError] = useState<string>("");
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleAddFile = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files) {
            const files = Array.from(event.target.files);
            setSelectedFiles(files);

            const fileTooLarge = files.find((file) => file.size > MAX_UPLOAD_SIZE_BYTES);
            if (fileTooLarge) {
                setUploadError(`${fileTooLarge.name} exceeds the 25MB file size limit.`);
                if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                }
                return;
            }

            setUploadError("");
            await addFile(selectedIssue.issueKey!, selectedIssue.reporter?.aapId!, files[0]);
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
        }
    };

    const handleBrowseClick = () => {
        fileInputRef.current?.click();
    };

    return (
        <Card sx={{ maxWidth: 400, margin: 2, boxShadow: 'none !important', border: 0 }}>
            <CardContent>
                <Typography variant="body2">
                    <strong>Upload Files:</strong>
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'center', my: 1 }}>
                    <Button variant="contained" size="small" onClick={handleBrowseClick}>
                        Browse Files
                    </Button>
                </Box>
                <input
                    type="file"
                    multiple
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleAddFile}
                    aria-label="Upload Files"
                />
                {uploadError && (
                    <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block' }}>
                        {uploadError}
                    </Typography>
                )}
            </CardContent>
        </Card>
    );
};

export default UploadBrowseCard;
